import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的自选职业ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入自选职业名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
  image_url: [
    {...makeRule('请上传示例图片', 'url', 'change')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/occupation/occupation.rules.js